import { render } from "./NftScreenshot.vue?vue&type=template&id=5901fa59&scoped=true"
import script from "./NftScreenshot.vue?vue&type=script&lang=js"
export * from "./NftScreenshot.vue?vue&type=script&lang=js"

import "./NftScreenshot.vue?vue&type=style&index=0&id=5901fa59&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5901fa59"]])

export default __exports__